module.exports = __webpack_public_path__ + "img/img-1.7a2c5597.webp";